module.exports = __webpack_public_path__ + "static/gallery-img-5-3949a99c02e6c9a66942b3a6af44366d.jpg";